import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { msg } from "@lingui/core/macro";
import { getAvailableSocialProviders } from "~/features/auth/auth.queries";
import { normalizePostAuthIntentSearchValue } from "~/features/auth/auth-routing";
import { getI18n } from "~/lib/i18n/i18n";
import LoginForm from "~/features/auth/components/login";
import { createPageHead } from "~/shared/lib/page-head";

const searchSchema = z.object({
  intent: z.preprocess(normalizePostAuthIntentSearchValue, z.string().optional()),
  redirect: z.string().optional(),
  reason: z.enum(["session_expired", "unauthorized"]).optional(),
});

export const Route = createFileRoute("/auth/login")({
  validateSearch: (search) => searchSchema.parse(search),
  loader: async () => ({
    socialProviders: await getAvailableSocialProviders(),
  }),
  head: () => createPageHead(getI18n()._(msg`Login`)),
  component: LoginRoute,
});

function LoginRoute() {
  const { intent, redirect, reason } = Route.useSearch();
  const { socialProviders } = Route.useLoaderData() as {
    socialProviders: Awaited<ReturnType<typeof getAvailableSocialProviders>>;
  };

  return (
    <LoginForm
      redirectPath={redirect}
      postAuthIntent={intent}
      loginReason={reason}
      socialProviders={socialProviders}
    />
  );
}
